import { Field as SwitchGroup, Label as SwitchLabel } from '@headlessui/react';
import { clstx } from '@payaca/utilities/cvaMerge';
import React, { FC, PropsWithChildren, ReactNode } from 'react';
import Card from '../Card/Card';
import Switch, { type SwitchProps } from './Switch';

export type SwitchCardProps = {
  label: string | ReactNode;
} & SwitchProps;

const SwitchCard: FC<PropsWithChildren<SwitchCardProps>> = (props) => {
  const { className, children, label, ...rest } = props;

  return (
    <Card>
      <Card.Body>
        <SwitchGroup>
          <SwitchLabel className="flex justify-between items-start cursor-pointer">
            {typeof label === 'string' ? <p>{label}</p> : label}
            <Switch className={clstx(className, 'shrink-0')} {...rest} />
          </SwitchLabel>
        </SwitchGroup>

        {children}
      </Card.Body>
    </Card>
  );
};

export default SwitchCard;
